<template>
    <div id="landingUser">
    </div>
</template>

<script>
export default {
    name: 'landingUser',
    data() {
        return {
            landingUserId : '',
        };
    },
    beforeCreate() {
    },
    created: function() {
        this.landingUserId = localStorage.getItem('landing_userid');
    },
    methods: {
        _gtag : function(){
            // 마케팅 GA 입력
            gtag('event', 'pageOpen', {
                'event_category': 'landing',
                'event_label': '페이지접속',
                'value': this.landingUserId
            });
            // console.log(this.landingUserId);
        },
        s4 : function() {
            return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        },
    },
    beforeDestroy() {
    },
    mounted(){
        this.$nextTick(() => { // 모든 화면이 렌더링된 후 호출됩니다. });
            if ( this.landingUserId === undefined || this.landingUserId === null || this.landingUserId === '' ) {
                let uuid =  this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
                if ( location.href.indexOf('dev.danbee.ai') > -1 || location.href.indexOf('localhost') > -1 ) {
                    uuid = 'dev_' + uuid;
                }
                localStorage.setItem('landing_userid', uuid);
                this.landingUserId = uuid;
                this._gtag();

                axios({
                    method : 'POST',
                    url : 'https:\/\/openapi.danbee.ai/openapis/user_access',
                    headers : {
                        'Content-Type' : 'application/json'
                    },
                    data : JSON.stringify({
                        'accessType': 'screen',
                        'accessUrl': 'landing',
                        'accessPrevUrl': '',
                        'uuid' : uuid,
                    })
                }).then((response) => {
                    // console.log('response : ');
                    // console.log(response);
                    let data = response.data;
                    if ( data.log_id ) {
                        localStorage.setItem('landing_accessLogId', data.log_id);
                    }
                }).catch((error) => {
                });

            } else {
                this._gtag();
            }
        });
    },
    computed: {

    },
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/landingUser.vue?2bedb8a8